import type { RecurringSchedule } from "@repo/app-types/scheduling/recurringSchedule";
import { FieldDescription } from "@repo/ui/field/fieldDescription";
import { RecurringScheduleFields } from "@repo/ui/scheduling/recurringScheduleFields";
import { Switch } from "@repo/ui/Switch/switch";
import type { FC } from "react";

const DEFAULT_SCHEDULE_TIME_OF_DAY = "08:00";

export interface KnowledgeBaseSyncIntegrationScheduleFieldsProps {
  syncSchedule: RecurringSchedule;
  autosyncEnabled: boolean;
  onScheduleChange: (schedule: RecurringSchedule) => void;
  onAutosyncEnabledChange: (enabled: boolean) => void;
  isDisabled: boolean;
}

export const KnowledgeBaseSyncIntegrationScheduleFields: FC<
  KnowledgeBaseSyncIntegrationScheduleFieldsProps
> = (props) => (
  <div className="space-y-3 rounded-md border border-border-light bg-card p-4">
    <div className="flex items-start justify-between gap-4">
      <div>
        <p className="text-sm font-medium">Automatic sync</p>
        <FieldDescription className="mt-1">
          Keep these knowledge bases up to date automatically. Scheduled times
          use Eastern Time.
        </FieldDescription>
      </div>
      <Switch
        accessibleLabel="Automatic sync"
        isSelected={props.autosyncEnabled}
        onChange={props.onAutosyncEnabledChange}
        isDisabled={props.isDisabled}
      />
    </div>
    {props.autosyncEnabled ? (
      <RecurringScheduleFields
        className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center"
        controlClassName="w-full sm:w-auto [&_button]:w-full"
        value={props.syncSchedule}
        onChange={props.onScheduleChange}
        isDisabled={props.isDisabled}
        seedTimeOfDay={DEFAULT_SCHEDULE_TIME_OF_DAY}
      />
    ) : null}
  </div>
);
